import {
  GET_HOWITWORK_PROFILE,
  GET_HOWITWORK_PROFILE_FAIL,
  GET_HOWITWORK_PROFILE_SUCCESS,
  GET_HOWITWORKS,
  GET_HOWITWORKS_FAIL,
  GET_HOWITWORKS_SUCCESS,
  ADD_NEW_HOWITWORK,
  ADD_HOWITWORK_SUCCESS,
  ADD_HOWITWORK_FAIL,
  UPDATE_HOWITWORK,
  UPDATE_HOWITWORK_SUCCESS,
  UPDATE_HOWITWORK_FAIL,
  DELETE_HOWITWORK,
  DELETE_HOWITWORK_SUCCESS,
  DELETE_HOWITWORK_FAIL,
} from "./actionTypes"

export const getHowitworks = ({is_active,offset='',page_size=''}) => ({
  type: GET_HOWITWORKS,
  payload:{is_active,offset,page_size}
})

export const getHowitworksSuccess = howitworks => ({
  type: GET_HOWITWORKS_SUCCESS,
  payload: howitworks,
})

export const getHowitworksFail = error => ({
  type: GET_HOWITWORKS_FAIL,
  payload: error,
})

export const addNewHowitwork = (user,history) => ({
  type: ADD_NEW_HOWITWORK,
  payload: {user,history},
})

export const addHowitworkSuccess = user => ({
  type: ADD_HOWITWORK_SUCCESS,
  payload: user,
})  

export const addHowitworkFail = error => ({
  type: ADD_HOWITWORK_FAIL,
  payload: error,
})

export const updateHowitwork = (howitwork,history) => ({
  type: UPDATE_HOWITWORK,
  payload: {howitwork,history},
})

export const updateHowitworkSuccess = user => ({
  type: UPDATE_HOWITWORK_SUCCESS,
  payload: user,
})

export const updateHowitworkFail = error => ({
  type: UPDATE_HOWITWORK_FAIL,
  payload: error,
})

export const deleteHowitwork = user => ({
  type: DELETE_HOWITWORK,
  payload: user,
})

export const deleteHowitworkSuccess = user => ({
  type: DELETE_HOWITWORK_SUCCESS,
  payload: user,
})

export const deleteHowitworkFail = error => ({
  type: DELETE_HOWITWORK_FAIL,
  payload: error,
})

export const getHowitworkProfile = (payload) => ({
  type: GET_HOWITWORK_PROFILE,
  payload:payload
})

export const getHowitworkProfileSuccess = userProfile => ({
  type: GET_HOWITWORK_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getHowitworkProfileFail = error => ({
  type: GET_HOWITWORK_PROFILE_FAIL,
  payload: error,
})
